import { title } from "process";
import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function CentralHubLayout() {
  const menu = [
    {
      key: ROUTES.CENTRAL.CENTRAL_DentistMillinglist,
      label: "Dentist Milling List",
      icon: "bi-clipboard2-pulse-fill",
      iconImage: "",
      order: 3,
    },


    {
      key: ROUTES.CENTRAL.ReplyRaiseTicket,
      label: "Reply Raise Ticket",
      icon: "bi-star-fill",
      iconImage: '',
      order: 4,
    },
    
 {
  key: ROUTES.CENTRAL.CENTRAL_PaymentTracking,
  label: "Payment Tracking",
  icon: "bi-wallet2",
  iconImage: '',
  order: 4,
},
 {
  key: ROUTES.CENTRAL.CENTRAL_PaymentInvoices,
  label: "Payment Invoices",
 icon: "bi-credit-card-2-front",
  iconImage: '',
  order: 4,
},


     {
      key: ROUTES.CENTRAL.WarrantyClaimResponse,
      label: "Reply Warranty Claim",
      icon: "bi-star-fill",
      iconImage: '',
      order: 4,
    },
    {
      key: ROUTES.CENTRAL.OrderSerachPage,
      label: ".Order Search Page",
      icon: "bi-search-heart",
      iconImage: '',
      order: 5
    },
  ];


  const menuGroups = [{
    order: 1,
    title: "Home"
    , icon: "bi-house-fill"
    , items: [{
      key: ROUTES.CENTRAL.CENTRAL_HUB_DashboardAdminCentralHub,
      label: "Dashboard",
      icon: "bi-speedometer",
      iconImage: ''
    }, {
      key:ROUTES.CENTRAL.CENTRAL_ApproveRejectCancelOrder,
      label: "Cancel Request Review",
      icon: "bi-x-octagon-fill",
      iconImage: ''
    },

     {
      key:ROUTES.CENTRAL.CENTRAL_ScheduleOrders,
      label: "ScheduleOrders",
      icon: "bi-x-octagon-fill",
      iconImage: ''
    },
    {
  key: ROUTES.CENTRAL.CENTRAL_FileManagement,
  label: "File Management",
  icon: "bi-folder-fill",
  iconImage: "",
},
     {
   
  key: ROUTES.CENTRAL.RatingAnalyticsTabs,
  label: "Rating Analytics",
  icon: "bi-trophy-fill",
  iconImage: ''

    },
    {
  key: ROUTES.CENTRAL.InternalPerformanceRating,
  label: "Internal Performance Rating",
  icon: "bi-trophy-fill",
  iconImage: ''

    },
    {
      key: ROUTES.CENTRAL.CENTRAL_CancelOrder,
      label: "Cancelled Orders",
      icon: "bi-x-octagon-fill",
      iconImage: ''
    },
 {
      key: ROUTES.CENTRAL.CENTRAL_CompleteOrder,
     label: "Complete Order",
      icon: "bi-patch-check-fill",
      iconImage: ''
    },

    
//        {
//         key: ROUTES.CENTRAL.AdminRealtimeOrderTracking,
//      label: "Realtime Order Tracking",
// icon: "bi-truck",
//         iconImage: ''
//       },
      
    {
      key: ROUTES.CENTRAL.AdminContactSupport,
      label: "Contact Support",
      icon: "bi-headset",
      iconImage: ''
    },

    {
      key: ROUTES.CENTRAL.SLABreachMonitor,
      label: "SLA Breach Monitor",
      icon: "bi-exclamation-triangle-fill",
      iconImage: ''
    },

  
     {
      key: ROUTES.CENTRAL.AdminRejectedOrder,
      label: "Reject Orders",
      icon: "bi-slash-circle-fill",
      iconImage: ''
    },]
  },
  {
    order: 4,
    title: "Delivery"
    , icon: "bi-truck-front-fill"
    , items: [
      {
        key: ROUTES.CENTRAL.CENTRAL_AdminDeliveryPartner,
        label: "Delivery Partner",
        icon: "bi-truck-front-fill",
        iconImage: ""
      }, {
        key: ROUTES.CENTRAL.CENTRAL_DispatchOverview,
        label: "DispatchOverview",
        icon: "bi-box-seam-fill",
        iconImage: ''
      },]
  },

  {
    order: 3,
    title: "User Management",
    icon: "bi-people-fill",
    items: [
      {
        key: ROUTES.CENTRAL.CENTER_APPROVALS,
        label: "Dentist/Hub Approvals",
        icon: "bi-person-check-fill",
        iconImage: ''
      },
    ]
  },
  {
    order: 5,
    title: "Master",
    icon: "bi-collection-fill",
    items: [
        {
        key: ROUTES.CENTRAL.ADD_MATERIAL,
        label: "Add Material",
        icon: "bi-box-fill",
        iconImage: ''
      },
       {
        key:ROUTES.CENTRAL.CENTRAL_Phasewisededuction,
        label: "Phase Wise Deduction",
       icon: "bi-cash-stack",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_AddDeliverypartner,
        label: "Add Delivery Partner",
        icon: "bi-person-plus-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.ScheduleMaster,
        label: "Add Delivery Slots",
        icon: "bi-person-plus-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.ADD_SHADE,
        label: "Add Shade",
        icon: "bi bi-plus-circle-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.ADD_REJECTION_REASON,
        label: "Rejection Reasons",
        icon: "bi-exclamation-octagon-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CANCELLATION_REASON,
        label: "Cancellation Reason",
        icon: "bi-chat-square-text",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.ADD_ORDER_TYPE,
        label: "Order Type",
        icon: "bi-menu-button-fill"
      },
      {
        key: ROUTES.CENTRAL.ADD_USERS,
        label: "Add Users",
        icon: "bi-people-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_HUB_ADDSLA,
        label: "AddSLA",
        icon: "bi-clock-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.TicketType,
        label: "Ticket Type",
        icon: "bi-tags-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.Priority,
        label: "Priority",
        icon: "bi-star-fill",
        iconImage: ''
      },


      {
        key: ROUTES.CENTRAL.ADD_GENERATECOUPON,
        label: "Generate Coupon",
        icon: "bi-ticket-perforated-fill"
      },
      {
        key: ROUTES.CENTRAL.USER_LOGIN_HISTORY,
        label: "User Login History",
        icon: "bi-stopwatch-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_HUB_CHECKBOXMASTER,
        label: "Check Box Master",
        icon: "bi-list-check",
        iconImage: ''
      },
    ],
  },
  {
    order: 2,
    title: "Reports",
    icon: "bi-bar-chart-fill",
    items: [
      {
        key: ROUTES.CENTRAL.CENTRAL_AdminReport,
        label: "Order Report",
        icon: "bi-bar-chart-fill",
        iconImage: ""
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_DesignerPerformance,
        label: "Designer Performance",
        icon: "bi-palette-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_MillingPerformance,
        label: "Milling Performance",
        icon: "bi-bar-chart-line-fill",
        iconImage: ''
      },
      {
        key: ROUTES.CENTRAL.CENTRAL_MillingResourceOverview,
        label: "Milling Resource Overview",
        icon: "bi-cpu-fill",
        iconImage: ''
      },



    ]
  }

  ];
  return (
    <GenericLayout
      menu={menu}
      menuGroups={menuGroups}
      titleLabel="Central Hub"
      profileRoute={ROUTES.CENTRAL.CENTRAL_PROFILE}
      showNotifications
      apiNotificationUrl={`${process.env.REACT_APP_API_BASE_URL}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
